import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component, useEffect } from "react";
import Board from "react-trello"; // import Board, { createTranslate } from 'react-trello';

import { SMCard as Card, Typography, Paper, numeral, makeStyles, setLocale } from "../../";
import "./SMBoard.css";
var useStyles = makeStyles(function (theme) {
  return {
    paper: {
      padding: "5px",
      background: theme.palette.primary.light,
      color: theme.palette.primary.contrastText
    },
    lane: {
      background: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      "text-align": "center",
      border: "0px"
    },
    priceHidden: {
      color: theme.palette.primary.light
    },
    board: {
      background: "transparent"
    }
  };
});

var CustomCard = function CustomCard(props) {
  // console.log("props custom", props);
  var classes = useStyles();
  var name = props.name,
      client = props.client,
      budget = props.budget,
      date = props.date,
      status = props.status,
      type = props.type,
      laneId = props.laneId,
      taskPipeline = props.taskPipeline,
      onClick = props.onClick,
      link = props.link,
      locale = props.locale;
  var data = {
    name: name,
    client: client,
    budget: budget,
    date: date,
    type: type,
    laneId: laneId
  }; // console.log("CustomCard locale", locale);

  useEffect(function () {
    setLocale(locale);
  }, [locale]);
  return /*#__PURE__*/React.createElement(Card, {
    className: classes.card,
    data: data,
    status: status,
    taskPipeline: taskPipeline,
    onClick: onClick,
    link: link,
    locale: locale
  });
};

var CustomLaneHeader = function CustomLaneHeader(props) {
  // console.log("header props", props);
  var classes = useStyles();
  var active = props.visibleFooter(props.id);
  return [/*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    square: true,
    className: [classes.lane, classes.paper].join(" "),
    key: "card_header_" + props.id
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      fontWeight: "bold"
    }
  }, props.title), !props.taskPipeline && (active ? /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, props.total(props.id)) : /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.priceHidden
  }, "-")))];
};

var SMBoard = /*#__PURE__*/function (_Component) {
  _inherits(SMBoard, _Component);

  var _super = _createSuper(SMBoard);

  function SMBoard(props) {
    var _this;

    _classCallCheck(this, SMBoard);

    _this = _super.call(this, props);

    _this.setEventBus = function (handle) {
      _this.setState({
        eventBus: handle
      });
    };

    _this.handleDragEnd = function (cardId, sourceLaneId, targetLaneId, position, cardDetails) {
      if (_this.props.handleCardDragBoard) {
        _this.props.handleCardDragBoard({
          cardId: cardId,
          sourceLaneId: sourceLaneId,
          targetLaneId: targetLaneId,
          position: position,
          cardDetails: cardDetails
        });
      }
    };

    _this.getStatusVisibleHeaderLaneFooter = function (id) {
      var active;

      if (_this.state.properties) {
        _this.state.properties.forEach(function (property) {
          if (property.id === id) {
            active = property.visible;
          }
        });

        return active;
      } else {
        return null;
      }
    };

    _this.laneSortFunction = function (a, b) {
      return a.position > b.position ? 1 : -1;
    };

    _this.getTotal = function (id) {
      var total = _this.state.boardData.lanes.find(function (lane) {
        return lane.id === id;
      }).cards.reduce(function (acc, card) {
        return acc + card.budget;
      }, 0);

      return numeral(total).format("0,0[.]00 $");
    };

    _this.shouldReceiveNewData = function (nextData) {
      // console.log("new data", nextData);
      _this.setState({
        boardData: nextData
      });

      if (_this.props.changeBoard) {
        _this.props.changeBoard(nextData);
      }
    };

    _this.onCardClick = function (cardId, metadata, laneId) {//  console.log("cardId,metadata,laneId", cardId, metadata, laneId);
    };

    _this.state = {
      boardData: _this.props.data,
      eventBus: undefined,
      properties: _this.props.properties
    };
    return _this;
  }

  _createClass(SMBoard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var components = {
        AddCardLink: function AddCardLink() {
          return _this2.props.addCardLink;
        },
        LaneHeader: function LaneHeader(props) {
          return /*#__PURE__*/React.createElement(CustomLaneHeader, Object.assign({
            total: _this2.getTotal,
            taskPipeline: _this2.props.taskPipeline,
            priceEmpty: _this2.props.priceEmpty
          }, props, {
            visibleFooter: _this2.getStatusVisibleHeaderLaneFooter
          }));
        },
        Card: function Card(props) {
          return /*#__PURE__*/React.createElement(CustomCard, Object.assign({
            taskPipeline: _this2.props.taskPipeline,
            locale: _this2.props.locale
          }, props));
        }
      };
      return /*#__PURE__*/React.createElement(Board, {
        data: this.props.data,
        draggable: this.props.draggable,
        handleDragEnd: this.handleDragEnd,
        laneDraggable: this.props.laneDraggable,
        canAddLanes: this.props.canAddLanes,
        cardDraggable: this.props.cardDraggable,
        onCardClick: this.props.onCardClick,
        eventBusHandle: this.setEventBus,
        onDataChange: this.shouldReceiveNewData,
        components: components,
        style: this.props.style || {
          backgroundColor: "transparent !important"
        }
      });
    }
  }]);

  return SMBoard;
}(Component);

export { SMBoard };